export default __webpack_public_path__ + "static/media/15.0344bf3e.png";